import { Roles } from '@/constants/roles';
import { Routes } from '@/constants/routes';
import { useParam } from '@/hooks';
import { Page } from '@/components/Page';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { TransactionsPageTemplate } from './components/TransactionsPageTemplate';
import {
  TransactionsTableCrypto,
  TransactionsTablePayment,
  TransactionsTableTransfer,
} from './components/TransactionsTable';
import { RouterSuspense } from '../../components/common';

const TABS = [
  {
    link: `/${Roles.PERSONAL}${Routes.TRANSACTIONS}`,
    name: 'Bank Transfer',
  },
  {
    link: `/${Roles.PERSONAL}${Routes.TRANSACTIONS}/bill-payment`,
    name: 'Bill Payment',
  },
  {
    link: `/${Roles.PERSONAL}${Routes.TRANSACTIONS}/buy-crypto`,
    name: 'Buy Crypto',
  },
  {
    link: `/${Roles.PERSONAL}${Routes.PROFILE_DETAILS}/referrals`,
    name: 'Refer & Earn',
  },
];

function TransactionsPagePersonal() {
  const { isDesktop } = useMediaQuery();
  const { param } = useParam<'bill-payment' | 'buy-crypto'>('slug');

  const renderSubRoute = () => {
    switch (param) {
      case 'bill-payment':
        return { title: 'Bill Payment', component: <TransactionsTablePayment /> };
      case 'buy-crypto':
        return { title: 'Buy Crypto', component: <TransactionsTableCrypto /> };
      default:
        return { title: 'Bank Transfer', component: <TransactionsTableTransfer /> };
    }
  };

  return (
    <Page title={`Transactions - ${renderSubRoute().title}`}>
      <TransactionsPageTemplate
        title="Invite & Earn"
        description={`Invite your friends to RelayPay to earn 0.10% of their eligible transaction volume. <a
          href="https://relaypay.io/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration: underline;"
        >
          T&Cs apply.
        </a>`}
        buttonLabel="Invite Friends"
        gradientSrc={
          isDesktop ? '/assets/TransactionsPersonalGradient.svg' : '/assets/TransactionsPersonalGradientMobile.svg'
        }
        variants="whiteBlue"
        tabs={TABS}
      >
        <RouterSuspense>{renderSubRoute().component}</RouterSuspense>
      </TransactionsPageTemplate>
    </Page>
  );
}

export default TransactionsPagePersonal;
